import React, { useState } from 'react'
import { Icon, IconButton, Menu } from '@material-ui/core'

function TableMultiSelectMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null)

  function openMenu(event) {
    setAnchorEl(event.currentTarget)
  }

  function closeMenu() {
    setAnchorEl(null)
  }

  return (
    <React.Fragment>
      <IconButton
        color="secondary"
        className="p-0"
        aria-owns={anchorEl ? 'selectMenu' : null}
        aria-haspopup="true"
        onClick={openMenu}
      >
        <Icon>more_vert</Icon>
      </IconButton>
      <Menu
        id="selectMenu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
      >
        {props.children(closeMenu)}
      </Menu>
    </React.Fragment>
  )
}

export default TableMultiSelectMenu
